import { Component } from '@angular/core';

@Component({
  selector: 'pm-modulos-list',
  templateUrl: './modulos-list.component.html',
  styleUrls: ['./modulos-list.component.sass']
})
export class ModulosListComponent {
  public pageTitle = 'Login';
  public showModulos = true;
  public showAddModulo = false;
  public showEditModulo = false;
  public editnumber = 0;
}
